import React, { useContext, useMemo } from 'react';
import { ALL_FEATURES } from './constants';
import { AuthContextType, AuthProviderProps } from './types';
import { isModalNavigation } from './utils';

const AuthContext = React.createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<AuthProviderProps> = ({
  children,
  features = ALL_FEATURES,
  navigation,
  promotionKey,
  referralKey,
  traceId,
}) => (
  <AuthContext.Provider
    value={useMemo(
      () => ({
        features,
        promotionKey,
        referralKey,
        traceId,
        // the odd syntax below informs typescript that if `navigationType === 'modal'`,
        // then `navigation` is of type AuthModalNavigationConfig and if
        // `navigationType === 'url'`, then `navigation` is of type
        // AuthUrlNavigationConfig
        ...(isModalNavigation(navigation)
          ? { navigation, navigationType: 'modal' }
          : { navigation, navigationType: 'url' }),
      }),
      [features, navigation, promotionKey, referralKey, traceId],
    )}
  >
    {children}
  </AuthContext.Provider>
);

export function useAuth() {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within AuthProvider');
  }

  return context;
}
